import { Api } from '../lib/Api/Api';
import { config } from '../../config';

export const api = new Api(config.apiUrl);
